module.exports = __webpack_public_path__ + "img/storybook.def8b99.png";